/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { EventArgs, markType } from "igniteui-react-core";
/**
 * @hidden
 */
var GridActiveCellChangedEventArgs = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(GridActiveCellChangedEventArgs, _super);
    function GridActiveCellChangedEventArgs() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._newActiveCell = null;
        _this._oldActiveCell = null;
        return _this;
    }
    Object.defineProperty(GridActiveCellChangedEventArgs.prototype, "newActiveCell", {
        get: function () {
            return this._newActiveCell;
        },
        set: function (a) {
            this._newActiveCell = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridActiveCellChangedEventArgs.prototype, "oldActiveCell", {
        get: function () {
            return this._oldActiveCell;
        },
        set: function (a) {
            this._oldActiveCell = a;
        },
        enumerable: true,
        configurable: true
    });
    GridActiveCellChangedEventArgs.$t = markType(GridActiveCellChangedEventArgs, 'GridActiveCellChangedEventArgs', EventArgs.$);
    return GridActiveCellChangedEventArgs;
}(EventArgs));
export { GridActiveCellChangedEventArgs };
//# sourceMappingURL=GridActiveCellChangedEventArgs.js.map
